import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-95afcd20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "addition" }
const _hoisted_2 = { class: "rel" }
const _hoisted_3 = { class: "text-rt mt_10 commit submit-btn" }
const _hoisted_4 = {
  key: 0,
  class: "primary mtrl-tip",
  style: {"font-size":"12px","line-height":"18px"}
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "btn-content" }

import { ref, computed, watch } from 'vue'
import AdtList from './components/AdtList.vue'
import AdtMtrl from './components/AdtMtrl.vue'
import { t } from '@/plugins/i18n'
import { adt, adtFn } from '@/util/useData'
import useCheckMap from '@/util/useCheckMap'
import { getDeli } from '@/util/calcAdt'
import { ElMessage } from 'element-plus'
import { getWarehouseByCountry, isD2C } from '@/store'
import AdtTemplate from './components/AdtTemplate.vue'
import useUtil from './index'
import confirmDialog from '@/components/common/ConfirmDialog'
import { useStore } from 'vuex'
import { COUNTRY } from '@/global'
import { getAdtList } from '@/apis/addition'

export default /*#__PURE__*/_defineComponent({
  props: ['cfg', 'amount', 'reback', 'hideAdtLoop', 'mustAdditionId', 'isCalculator', 'countryCode', 'choiceCost', 'isStockJp'],
  emits: ['beforeClose', 'update:cfg', 'save'],
  async setup(__props, { emit }) {

let __temp: any, __restore: any

const props = __props
const store = useStore()
const {
  additionSort,
  sortAdd,
  scrollView
} = useUtil()

// mustAdditionId 必选附加项
// isCalculator 是否成本计算器-成本计算器获取附加项，非会员取最高等级会员附加项计算
// countryCode 国家 CN KR
// isStockJp  是否囤货到日本的附加项


const [adtMap, change] = useCheckMap(
  props.cfg ? JSON.parse(JSON.stringify(props.cfg)) : [],
  'additionId'
)
const isLogin = computed(() => store.getters.isLogin)
const getStockJpAddition = () => getAdtList({ productType: 1, overseasInvFlag: 1 }).then(v => v.data)
const adtApi: any = computed(() => {
  if (props.isStockJp) {
    return getStockJpAddition
  }
  return (props.isCalculator || !isLogin.value) ? () => adtFn(1) : adt
})
const adtRes: any = ref([])
const warehouseCode = getWarehouseByCountry(props.countryCode)

adtRes.value = (
  ([__temp,__restore] = _withAsyncContext(() => adtApi.value(warehouseCode).then((data: any) => {
  console.log(props.countryCode, warehouseCode)
  return data.deliveryAdditionList.map((v: any) => {
    const t = { ...v }
    if (adtMap[t.additionId]) {
      // 附加项列表添加已配置的辅料sku
      t.ingredientsSku = adtMap[t.additionId].ingredientsSku
      adtMap[t.additionId].ingredientStatus = t.ingredientStatus
    }
    if (t.additionCode === 23) {
      t.additionMsg = '$THE CKB通用纸箱说明$'
    }
    if (t.additionCode === 42) {
      t.additionMsg = '$THE CKB发货袋说明$'
    }
    if (t.additionCode === 65) {
      t.additionMsg = '$厂家原箱说明$'
    }
    // 返回重新生成的附加项列表
    return t
  })
}))),
  __temp = await __temp,
  __restore(),
  __temp
)
// 删除已不存在的附加项
// Object.keys(adtMap).forEach((key:any) => {
//   const k = adtRes.find((v:any) => v.additionConfigId === adtMap[key].additionConfigId)
//   if (!k) delete adtMap[key]
// })



const visible = ref(true)

const changeAdt = (v: any, toState: any) => {
  if (props.mustAdditionId?.indexOf(String(v.additionCode)) > -1 && !toState) {
    return
  }
  sortAdd(v, toState)
  change({
    additionConfigId: v.additionConfigId,
    // TODO additionCode
    additionId: v.additionId,
    additionCode: v.additionCode,
    ingredientsSku: v.ingredientsSku || '',
    additionNameJp: v.additionNameJp,
    ingredientStatus: v.ingredientStatus,
    linkCancelOptionList: v.linkCancelOptionList,
    linkMutexOptionList: v.linkMutexOptionList,
    linkSelectionOptionList: v.linkSelectionOptionList
  }, toState)
}

const flash: any = ref([])
const commit = () => {
  confirmDialog({
    title: t('提示3') + '!',
    text: `${t('在国际发货时，如果包含易碎或尖锐的物品，建议选择气泡膜或者缓冲垫。')}<br>${t('气泡膜体积较小，但是保护作用会比缓冲垫差一点。')}<br>${t('缓冲垫体积较大，但是保护作用较强。')}<br/>${t('您也可以选择同时使用两种缓冲材。不管是哪种方式都无法确保100%不破损。')}`,
    htmlNode: true,
    okText: t('确认'),
    cancelText: t('关闭'),
    closeOnClickModal: false
  }).then(() => {
    console.log('additionSort', additionSort.value)
    const additionList = Object.values(additionSort.value).map((v: any) => {
      const { ingredientStatus, ...others } = v
      return {
        ...others,
        spotCheckFlag: v.spotCheckRatio && v.spotCheckFlag === 1 ? 1 : 0
      }
    })
    const keys = [[23, 65, 66, 69], [42, 43]]
    const is2c = isD2C() ? 1 : 0
    const require = additionList.some(v => keys[is2c].includes(v.additionCode))
    console.log(additionList)
    if (!require && !props.isStockJp) {
      flash.value = keys[is2c]
      setTimeout(() => {
        flash.value = []
      }, 3600)
      ElMessage.error(is2c ? t('发货袋附加项必须选择一种') : t('纸箱类附加项必须选择一种'))
      return
    }
    emit('update:cfg', additionList)
    emit('save', additionList)
    emit('beforeClose')
    visible.value = false
  }).catch(() => {
    visible.value = false
  })
}

const cancel = () => {
  // visible.value = false
  emit('beforeClose', true)
}

const reset = () => {
  const warehouseCode = getWarehouseByCountry(props.countryCode)
  getDeli(warehouseCode).then(async (res: any) => {
    Object.keys(adtMap).forEach(k => {
      delete adtMap[k]
    })
    const ids = res.map((v: any) => v.additionId)
    adtRes.value.filter((v: any) => ids.includes(v.additionId)).forEach((v: any) => {
      adtMap[v.additionId] = v
    })
  })
}

const adtListRef = ref()
additionSort.value = Object.values(adtMap)
const setdefault = async (items: any) => {
  Object.keys(adtMap).forEach((k) => {
    if (props.mustAdditionId?.indexOf(String(adtMap[k].additionCode)) > -1) return
    delete adtMap[k]
  })
  items.forEach((v: any) => {
    adtMap[v.additionId] = {
      ...v,
      // 保留原先附加项configid
      additionConfigId: adtRes.value.find((i: any) => i.additionId === v.additionId)?.additionConfigId
    }
    adtListRef.value.linkageAddition(true, v)
  })
  additionSort.value = Object.values(adtMap)
  // 如果存在辅料的附加项则滚动到底部
  if (additionSort.value.filter((i: any) => i.ingredientStatus).length > 0) {
    scrollView()
  }
}

// 是否选择辅料
const isMtrl = computed(() => {
  return Object.values(adtMap).filter((v: any) => v.ingredientStatus)?.length > 0
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!__props.hideAdtLoop && props.countryCode != _unref(COUNTRY).JP)
        ? (_openBlock(), _createBlock(_Suspense, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(AdtTemplate, {
                type: "2",
                adt: adtRes.value,
                onSetdefault: setdefault,
                countryCode: __props.countryCode
              }, null, 8, ["adt", "countryCode"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(), _createBlock(_Suspense, null, {
          default: _withCtx(() => [
            _createVNode(AdtList, {
              onChange: _cache[0] || (_cache[0] = e => changeAdt(e[0], e[1])),
              isDeli: true,
              adt: adtRes.value,
              "adt-map": _unref(adtMap),
              flash: flash.value,
              ref: (_value, _refs) => {
                _refs['adtListRef'] = _value
                adtListRef.value = _value
              },
              choiceCost: __props.choiceCost,
              isStockJp: __props.isStockJp
            }, null, 8, ["adt", "adt-map", "flash", "choiceCost", "isStockJp"])
          ]),
          _: 1
        })),
        (_unref(isLogin) && __props.countryCode !== _unref(COUNTRY).KR)
          ? (_openBlock(), _createBlock(AdtMtrl, {
              key: 0,
              countryCode: __props.countryCode,
              "adt-map": _unref(adtMap),
              amount: __props.amount,
              sort: _unref(additionSort)
            }, null, 8, ["countryCode", "adt-map", "amount", "sort"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_unref(isMtrl) && __props.countryCode !== _unref(COUNTRY).KR)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("span", {
              innerHTML: _unref(t)('客户资材必须得提前先下好，保存在仓库，否则无法对应').split('\n').map((v) => `<span>${v}</span>`).join('<br/>')
            }, null, 8, _hoisted_5)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        (__props.reback)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "default",
              onClick: reset
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('一键配置店铺配置发货附加项')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_button, {
          type: "default",
          onClick: cancel
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: commit
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('确认')), 1)
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}
}

})